<!-- eslint-disable -->
<template lang="pug">
    form.fields(action="javascript://", @submit="sendForm")
        .fields__element
            label.fields__label {{ $i18n.t('fields.fields_sort') }}
            cs-multiselect.fields__input(
                :multiple="false",
                :options="sort",
                :show-labels="false",
                :placeholder="$i18n.t('fields.fields_sortPlaceholder')",
                :searchable="false",
                track-by="by",
                label="label",
                v-model="form.sort"
            )
        .fields__element
            label.fields__label {{ $i18n.t('fields.fields_status') }}
            cs-multiselect.fields__input(
                :multiple="false",
                :options="statuses",
                :show-labels="false",
                :allow-empty="false",
                :custom-label="getStatusName",
                placeholder="",
                v-model="form.status",
                :searchable="false"
            )
        .fields__element
            label.fields__label {{ $i18n.t('fields.fields_search') }}
            cs-search-input.fields__input(
                :placeholder="$i18n.t('fields.list_schoolPlaceholder')",
                v-model="form.name"
                @search="sendForm"
            )
        .fields__element
        .fields__element.fields__element--fluid
            cs-button(
                color="blue",
                pattern="primary-outline",
                html-tag="a"
                href="javascript://"
                @click="resetResults",
                narrow
            )
                | {{ $i18n.t('fields.fields_dropParameters') }}
</template>

<script>
    /*eslint-disable*/
    import _ from 'lodash';
    import searchParamsStore from '../utils/searchParamsStore'
    import statusFieldMixin from '../utils/statusFieldMixin'

    export default {
        mixins: [searchParamsStore, statusFieldMixin],
        mounted () {
            if (this.$route.name.includes('billing')) {
                this.type = 'billing';
            }
        },
        data() {
            return {
                sort: [{label: this.$i18n.t('fields.list_sortName'), by: 'name'}],
                form: {
                    sort: null,
                    name: null,
                    status: 'active'
                },
                type: "",
            }
        },
        watch: {
            '$route.query' (val) {
                if (_.isEmpty(val)) {
                    this.form = _.cloneDeep(this.localSearchParams) || {
                        sort: null,
                        name: null,
                        status: 'active'
                    };
                }
            },
            'form.sort' () {
                this.updateList()
            },
            'form.name'() {
                this.updateList()
            },
            'form.status'() {
                this.updateList()
            },
        },
        methods: {
            sendForm() {
                this.$emit(
                        'search',
                        Object.assign({}, this.form, {
                            sort: _.has(this.form, 'sort.by') ? this.form.sort.by : null
                        })
                );
            },
            resetResults() {
                this.$emit('search', this.form = {
                    sort: null,
                    name: null,
                    status: 'active'
                });
            },
            updateList: _.debounce(function() {
                this.sendForm()
            }, 1000)
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../assets/sass/fields/fields.scss";
</style>
